import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listReponses } from '../redux/actions/ListReponsesActions';
import { Button } from 'antd';

const Test = () => {
  const dispatch = useDispatch();
  const listResponse = useSelector((state) => state.listReponses);
  const data = listResponse?.responses?.data || [];
  const formId = 114;

  useEffect(() => {
    dispatch(listReponses(formId));
  }, [formId, dispatch]);

  const handleClick = () => {
    if (!data || data.length === 0) return;

    const allLabels = new Set();
    data.forEach((response) => {
      response.Answers.forEach((answer) => {
        allLabels.add(answer.Field.label);
      });
    });
    const headers = Array.from(allLabels);

    const rows = data.map((response) => {
      const labelValueMap = {};
      response.Answers.forEach((answer) => {
        const label = answer.Field.label;
        let value = answer.value;

        try {
          const parsed = JSON.parse(value);
          value = Array.isArray(parsed) ? parsed.join(', ') : parsed;
        } catch {}

        labelValueMap[label] = value;
      });

      return headers
        .map((label) => `"${(labelValueMap[label] ?? '').toString().replace(/"/g, '""')}"`)
        .join(',');
    });

   const csv = [headers.join(','), ...rows].join('\n');

   const blob = new Blob([csv], { type: 'text/csv' });
const fileURL = URL.createObjectURL(blob);

// Ouvre Google Sheets vide
window.open("https://docs.google.com/spreadsheets/u/0/create", "_blank");

// Déclenche le téléchargement
const a = document.createElement("a");
a.href = fileURL;
a.download = "reponses.csv";
document.body.appendChild(a);
a.click();
document.body.removeChild(a);

  };

  return (
    <div style={{ padding: 20 }}>
      <Button type="primary" onClick={handleClick}>
        Ouvrir les réponses dans le navigateur
      </Button>
    </div>
  );
};

export default Test;
